import React from "react";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useFormik } from "formik";
import { useState, useEffect } from "react";
import { classNames } from "primereact/utils";
import { timesheetApi, allocationService } from "../../../../services";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Calendar } from "primereact/calendar";
import { toast } from "react-toastify";
import moment from "moment";
import properties from "../../../../config/environmentProperties";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const UserCreateAllocationDialog = ({ onClose, userData }) => {
  const [allocType, setAllocType] = useState([]);
  const [checkBillable, setCheckBillable] = useState(false);
  const imgPath = properties.currentEnvironment.docPath + "images/";
  const [projects, setProjects] = useState([]);
  const [allocatedPro, setAllocatedPro] = useState([]);
  const [fullAllocationDisabled, setFullAllocationDisabled] = useState(false);
  const [partialAllocationDisabled, setPartialAllocationDisabled] = useState(false);
  const [otAllocationDisabled, setOtAllocationDisabled] = useState(false);
  let count = 0;


  const [resourceRole, setResourceRole] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState({});

  useEffect(() => {
    if (count === 0) {
      count++;
      getAllocationTypes();
      getProjects();
      let allocatedProject = [];
      allocatedProject = userData.Allocations.filter((el) => {
        return el.status !== 4;
      });
      setAllocatedPro(allocatedProject);

      if (userData.availability === 100) {
        formik.setFieldValue("alloc100", true);
        formik.setFieldValue("allocPartial", false);
        formik.setFieldValue("ot", false);
        setFullAllocationDisabled(false);
        setPartialAllocationDisabled(false);
        setOtAllocationDisabled(true);
      } else if (userData.availability === 0) {
        formik.setFieldValue("ot", true);
        formik.setFieldValue("allocPartial", false);
        formik.setFieldValue("alloc100", false);
        setFullAllocationDisabled(true);
        setPartialAllocationDisabled(true);
        setOtAllocationDisabled(false);
      } else {
        formik.setFieldValue("allocOther", userData.availability);
        formik.setFieldValue("allocPartial", true);
        formik.setFieldValue("ot", false);
        formik.setFieldValue("alloc100", false);
        setFullAllocationDisabled(true);
        setPartialAllocationDisabled(false);
        setOtAllocationDisabled(true);
      }
    }
  }, []);

  const getProjects = () => {
    timesheetApi.getAllProjectByAdmin().then((resp) => {
      setProjects(resp?.data?.data);
    });
  };

  let userListDetails = [
    {
      name: userData.firstName.toUpperCase() + " " + userData.lastName.toUpperCase(),
      id: userData.id,
      isBillable: checkBillable,
      designation: userData?.Designation?.title,
    },
  ];

  const getAllocationTypes = () => {
    allocationService.getAllocationtypes().then((resp) => {
      setAllocType(resp.data.data);
    });
  };

  const formik = useFormik({
    initialValues: {
      projects: "",
      resourceRole: "",
      billingRate: "",
      allocation: 0,
      alloc100: false,
      allocOther: "",
      allocPartial: false,
      ot: false,
      startDate: "",
      endDate: "",
      user: "",
      reason: "",
    },
    validate: (data) => {
      let errors = {};
      if (!data.projects) {
        errors.projects = "Please select project";
      }
      if (Object.keys(selectedRowData).length === 0) {
        errors.resourceRole = "please select role for this project*";
      }
      if (!data.startDate) {
        errors.startDate = "Start Date is required*";
      }
      if (!data.endDate) {
        errors.endDate = "End Date is required*";
      }
      if (data.endDate && data.startDate) {
        if (moment(data.startDate) > moment(data.endDate)) {
          errors.endDate = "End Date is must be above than start date";
        }
      }
      if (data.allocOther > userData.availability) {
        errors.allocOther = "Allocation should not be greater than availablity (" + userData.availability + "%)";
      }
      return errors;
    },
    onSubmit: (data) => {
      createAllocation(data);
      formik.resetForm();
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const fetchProjectId = (name) => {
    var found;
    projects.map((item) => {
      if (item.title === name) {
        found = item.id;
      }
    });
    return found;
  };


  const fetchProjectStartEndDate = (name) => {
    let obj;
    projects.map((item) => {
      if (item.title === name) {
        obj = item
      }
    });
    return obj;
  }

  const createAllocation = async (data) => {
    const dataobj = {
      projectId: fetchProjectId(data.projects),
      projectRoleId: selectedRowData?.id,
      billingRateId: selectedRowData?.billingRate[0]?.id,
      startDate: moment(data.startDate).format("YYYY-MM-DD"),
      endDate: moment(data.endDate).format("YYYY-MM-DD"),
      allocationType: fetchAllocation(data),
      percentage: fetchPercentage(data),
      users: userListDetails,
    };
    if (formik.values.alloc100 || formik.values.allocOther > 0 || formik.values.ot) {
      try {
        allocationService.createManagerAllocation(dataobj).then(
          (resp) => {
            onClose();
            toast.success("Allocated successfully");
          },
          (err) => {
            toast.error(err.response.data.error);
          }
        );
      } catch (error) {
        toast.error("Unable to create allocation...");
      }
    } else {
      toast.error("Allocation percentage not selected properly");
    }
  };

  const fetchAllocation = (data) => {
    var code = "100";
    if (data) {
      if (data.alloc100) {
        code = "100";
      } else if (data.allocPartial) {
        code = "PT";
      } else if (data.ot) {
        code = "OT";
      } else {
        code = "";
      }
    }
    var result = allocType.filter((obj) => {
      return obj.code === code;
    });
    return result[0].id;
  };

  const fetchPercentage = (data) => {
    var result = null;
    if (data) {
      if (data.alloc100) {
        result = 100;
      } else if (data.allocPartial) {
        result = data.allocOther;
      } else {
        result = 0;
      }
    }
    return result;
  };

  const allocHandler = (e) => {
    formik.handleChange(e);
    if (!formik.values.allocPartial) {
      formik.values.allocOther = "";
    }

    switch (e.target.name) {
      case "allocPartial":
        formik.setFieldValue("alloc100", false);
        formik.setFieldValue("ot", false);
        break;
      case "alloc100":
        formik.setFieldValue("allocPartial", false);
        formik.setFieldValue("ot", false);
        break;
      case "ot":
        formik.setFieldValue("alloc100", false);
        formik.setFieldValue("allocPartial", false);
        break;
      default:
    }
  };

  const handleDateChange = (date) => {
    formik.setFieldValue("startDate", date);
    formik.setFieldValue("endDate", "");
  };

  const handleBillable = (e) => {
    if (userData) {
      if (checkBillable) {
        setCheckBillable(false);
      } else {
        setCheckBillable(true);
      }
    }
  };

  const projectBodyTemplate = (rowData) => {
    return rowData?.Project?.title;
  };



  const changeProject = (e) => {
    let selectedProjectId = fetchProjectId(e.value);
    let projectDateObj = fetchProjectStartEndDate(e.value);
    // getResourceRole(selectedProjectId);
    formik.handleChange(e);

    allocationService.getAllResourceRole(selectedProjectId).then((resp) => {
      setResourceRole(resp?.data?.data);
      formik.setFieldValue("startDate", new Date(projectDateObj.startDate));
      formik.setFieldValue("endDate", new Date(projectDateObj.endDate));
    });
  }

  const onRowClick = (event) => {
    setSelectedRowData(event.data);
  };

  const rowClass = (rowData) => {
    return {
      'job-expended-row': rowData?.id === selectedRowData?.id
    }
  }

  const rateBody = (rowData) => {
    return (<>{rowData?.billingRate[0]?.currency + " " + rowData?.billingRate[0]?.rate + " " + rowData?.billingRate[0]?.billingType?.title}</>);
  }


  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="p-fluid">
        <div className="field">
          <label htmlFor="name" className={classNames({ "p-error": isFormFieldValid("name") })}>
            Project*
          </label>
          <span className="p-float-label">
            {/* <Dropdown filter id="projects" name="projects" placeholder="Select Project" optionLabel="title" optionValue="title" options={projects} onChange={formik.handleChange} value={formik.values.projects} appendTo="self" /> */}
            <Dropdown filter id="projects" name="projects" placeholder="Select Project" optionLabel="title" optionValue="title" options={projects} onChange={(e) => changeProject(e)} value={formik.values.projects} appendTo="self" />
          </span>
          {getFormErrorMessage("projects")}
        </div>

        <div className="grid date-selection">
          <Accordion activeIndex={0} style={{ minWidth: '30rem' }}>
            <AccordionTab header="Resource Role & Rate">
              <DataTable dataKey="id" value={resourceRole} tableStyle={{ minWidth: '30rem' }} selectionMode="single" onRowClick={onRowClick} rowClassName={rowClass}>
                <Column field="title" header="Role" headerStyle={{ width: "15rem" }}></Column>
                <Column field="startDate" header="Start Date" headerStyle={{ width: "10rem" }}></Column>
                <Column field="endDate" header="End Date" headerStyle={{ width: "10rem" }}></Column>
                <Column field="count" header="No Of Position" headerStyle={{ width: "10rem" }}></Column>
                <Column field="title" header="Rate" headerStyle={{ width: "12rem" }} body={rateBody}></Column>
              </DataTable>
            </AccordionTab>
          </Accordion>
        </div>
        {getFormErrorMessage("resourceRole")}

        <div className="grid date-selection">
          <div className="col">
            <div className="field">
              <label htmlFor="date">Start Date*</label>
              <span className="p-float-label">
                <Calendar type="date" id="date" name="startDate" value={formik.values.startDate} onChange={(e) => handleDateChange(e.target.value)} dateFormat="dd/mm/yy" mask="99/99/9999" showIcon placeholder="Start Date" />
                {getFormErrorMessage("startDate")}
              </span>
            </div>
          </div>
          <div className="col">
            <div className="field">
              <label htmlFor="date">End Dates*</label>
              <span className="p-float-label">
                <Calendar type="date" id="date" name="endDate" value={formik.values.endDate} onChange={formik.handleChange} dateFormat="dd/mm/yy" mask="99/99/9999" showIcon placeholder="End Date" minDate={new Date(formik.values.startDate)} disabled={!formik.values.startDate} />
                {getFormErrorMessage("endDate")}
              </span>
            </div>
          </div>
        </div>
        {userData && (
          <div className="user-container">
            {userListDetails.map((item, i) => {
              return (
                <div>
                  <div className="grid">
                    <div className="col-2">
                      <div className="flex align-items-center gap-2">
                        {userData?.photo === "" ||
                          userData?.photo === null ? (
                          <span className="photo-span" style={{ height: "35px", width: "35px", borderRadius: "50%", border: "2px solid #d7e9ff", display: "flex", alignItems: 'center', justifyContent: 'center', fontSize: "18px", fontWeight: "600", color: "#1369b6", padding: '5px', paddingTop: '1px' }}>
                            {userData.firstName.toUpperCase().substr(0, 1)}
                            {userData.lastName.toUpperCase().substr(0, 1)}
                          </span>
                        ) : (
                          <img style={{ height: "50px", width: "50px", borderRadius: "50%", border: "3px solid #d7e9ff", Top: "16px", bottom: "16px", left: "16px" }} src={imgPath + userData?.photo || ""} alt="" />
                        )}
                      </div>
                    </div>
                    <div className="col-6">
                      <span className="userName"> <b> {item.name}</b>{" "} </span>
                      <br />
                      <span className="userName"> <div> {item.designation} </div> </span>
                      <span className="userName">Availability :<b> {userData.availability} %</b> </span>
                    </div>
                    <div className="col-4">
                      <div className="grid">
                        <div className="col-3 mt-2">
                          <Checkbox id={item.id} name={item.name} checked={item.isBillable} onChange={handleBillable} />
                        </div>
                        <div className="col-3 mt-2">Billable</div>
                      </div>
                    </div>
                  </div>
                  <Accordion activeIndex={null}>
                    <AccordionTab header="Resource Allocation">
                      <DataTable value={allocatedPro} responsiveLayout="scroll">
                        <Column field="id" header="ID" style={{ minWidth: "5rem" }}></Column>
                        <Column field="project" body={projectBodyTemplate} header="Project" style={{ minWidth: "15rem" }}></Column>
                        <Column field="percentage" header="Allocation(%)" style={{ minWidth: "8rem" }}></Column>
                      </DataTable>
                    </AccordionTab>
                  </Accordion>
                </div>
              );
            })}
          </div>
        )}

        <div className="grid">
          <label htmlFor="name" className={classNames({ "p-error": isFormFieldValid("name") })}></label>
          <div className="col-4">
            <div className="field-checkbox">
              <Checkbox className="mt-4" id="alloc100" name="alloc100" checked={formik.values.alloc100} onChange={allocHandler} disabled={fullAllocationDisabled} />
              <label className="checkbox-label allocationSelection" htmlFor="alloc100"> 100% Allocation </label>
            </div>
          </div>
          <div className="col-5">
            <div className="field-checkbox">
              <Checkbox className="mt-4" id="allocPart" name="allocPartial" checked={formik.values.allocPartial} onChange={allocHandler} disabled={partialAllocationDisabled} />
              <label className="checkbox-label allocationSelection" htmlFor="allocPart"> Partial Allocation </label>
            </div>
          </div>
          <div className="col-3">
            <div className="field-checkbox mr-4">
              <Checkbox className="mt-4" id="allocOt" name="ot" checked={formik.values.ot} onChange={allocHandler} disabled={otAllocationDisabled} />
              <label className="checkbox-label ml-3 allocationSelection" htmlFor="allocOt"> OT </label>
            </div>
          </div>
        </div>
        {formik.values.allocPartial && (
          <div className="partial-container">
            <div className="grid">
              <div className="col-4">
                <label htmlFor="other">Partial Allocation %</label>
              </div>
              <div className="col-8">
                <InputText id="allocOther" name="allocOther" style={{ width: "50px" }} value={formik.values.allocOther} onChange={(e) => {
                  if (e.target.value < 100) {
                    formik.handleChange(e);
                  }
                }}
                />
              </div>
              {getFormErrorMessage("allocOther")}
            </div>
          </div>
        )}
      </div>
      <div className="" style={{ textAlign: "right", marginTop: "20px", marginBottom: "10px" }}>
        <Button type="button" label="Cancel" className="p-button-rounded p-button-secondary" onClick={() => {
          onClose();
          formik.resetForm();
        }}
        />
        <Button label="Allocate Now" className="p-button-rounded ml-2" />
      </div>
    </form>
  );
};
export default UserCreateAllocationDialog;